import { FC } from 'react';
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from 'recharts';
import { chartColorList } from './constants';
import { groupLineDataByKey } from './utils';
import { ChartAttachment, RadarChartData } from '../../pages/Chat/Chat/types';

const MindyRadarChart: FC<ChartAttachment> = ({ data }) => {
    if (
        !Array.isArray(data) ||
        data.some((point) => Object.keys(point).length < 3) ||
        data.some((point) => !Object.keys(point).includes('subject') || !Object.keys(point).includes('fullMark'))
    ) {
        console.error(
            'Invalid data format for RadarChart. Expected an array of objects with at least three keys: subject, fullmark and value.',
        );
        return null;
    }
    const dataGrouped = groupLineDataByKey(data as RadarChartData[]);
    const filteredByAxisKey = Object.fromEntries(
        Object.entries(dataGrouped).filter(([key]) => !['subject', 'fullMark'].includes(key)),
    );

    return (
        <div className="w-full h-[250px]">
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart height={250} width={730} cx="50%" cy="50%" outerRadius="80%" data={data}>
                    <PolarGrid />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis />
                    {Object.keys(filteredByAxisKey).map((key, index) => (
                        <Radar
                            name={key}
                            dataKey={key}
                            stroke={chartColorList[index % chartColorList.length]}
                            fill={chartColorList[index % chartColorList.length]}
                            fillOpacity={0.6}
                        />
                    ))}
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default MindyRadarChart;
